import Link from 'next/link'
import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { PlusSVG, Tooltip } from '@ensdomains/thorin'

const Container = styled.div(
  ({ theme }) => css`
    padding: ${theme.space['2']};
    background: ${theme.colors.greenSurface};
    border-radius: ${theme.radii.input};
    font-weight: ${theme.fontWeights.bold};
    width: fit-content;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: ${theme.space[1]};
    & > svg {
      color: ${theme.colors.green};
      width: ${theme.space[5]};
    }
  `,
)

const Points = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.headingFour};
    color: ${theme.colors.greenPrimary};
  `,
)

const PointsTag = ({
  name,
  registrationYears,
  hideIcon,
}: {
  name: string
  registrationYears: number
  hideIcon?: boolean
}) => {
  const [points, setPoints] = useState(0)
  const [nameLength, setNameLength] = useState(0)

  useEffect(() => {
    setNameLength(name.split('.')[0].length)
  }, [name])

  useEffect(() => {
    let basePoints = 0

    if (nameLength === 3) {
      // 3 name length
      basePoints = 100
    } else if (nameLength === 4) {
      // 4 name length
      basePoints = 25
    } else if (nameLength > 4) {
      // 5+ name length
      basePoints = 1
    }

    setPoints(Math.floor(basePoints * registrationYears))
  }, [nameLength, registrationYears])

  return (
    <Tooltip
      content={
        <>
          <div>
            Points are awarded based on the length of the name and the duration of the registration.
          </div>
          <Link
            href="https://docs.qns.club/en/articles/10254371-testnet-incentives-mainnet-username-rollout"
            passHref
            target="_blank"
            rel="noreferrer noopener"
            style={{
              color: 'inherit',
              textDecoration: 'underline',
            }}
          >
            Learn more
          </Link>
        </>
      }
      background="greenSurface"
    >
      <Container>
        {!hideIcon && <PlusSVG />}
        <Points>{points} Points</Points>
      </Container>
    </Tooltip>
  )
}

export default PointsTag
